<template>
    <TablePage
        class="px-0 2xl:px-10 pb-2"
        :module-name="moduleName"
        :response="response"
        :isLoading="isLoading"
        :tableHeaders="tableHeaders"
        :filters="researchAssignmentsFilter"
        :bulkOperations="researchAssignmentsBulkOperations"
        :menuOptions="menuOptions"
        @refetch-results="loadResearchAssignments"
        @clear-filter="clearFilter"
        @change-filters="setFilters"
        @set-filter-options="setFilterOptions"
    >
        <template #table-row="{ events: {  }, selectAll, userPermissions }">
            <ResearchAssignmentRow
                v-for="researchAssignment in response.data.results"
                :key="researchAssignment.id"
                :research-assignment="researchAssignment"
                :selectAll="selectAll"
                :userPermissions="userPermissions"
                :user-options="userOptions"
                :is-loading="isLoading"
            />
        </template>
    </TablePage>
</template>

<script setup>
import { ref, reactive, } from 'vue';
import { useStore } from 'vuex';
import { getResearchAssignments } from '@/services/ResearchAssignment';
import TablePage from "@/components/base-components/TablePage";
import { formatDate } from '@/composables/formatDate';
import ResearchAssignmentRow from './ResearchAssignmentRow.vue';
import { getUsersByGroup, getUsers } from '@/services/User'

const store = useStore()
const isLoading = ref(false)
const moduleName = ref('Research Assignments')
const response = ref(null)
const userOptions = ref([])
const tableHeaders = ref([
    {
        value: 'assignment_name',
        label: 'Assignment Name',
        class: 'p-0 w-1/4  whitespace-nowrap'
    },
    {
        value: 'research_page',
        label: 'Research Page',
        class: 'p-0 w-1/4  whitespace-nowrap'
    },
    {
        value: 'user',
        label: 'User',
        class: 'p-0 w-1/8  whitespace-nowrap'
    },
    {
        value: 'assigned_at',
        label: 'Assigned At',
        class: 'p-0 w-1/8  whitespace-nowrap '
    },
    {
        value: 'status',
        label: 'Status',
        class: 'p-0 w-1/8  whitespace-nowrap '
    },
    {
        value: 'initial_company_count',
        label: 'Initial Count',
        class: 'p-0 w-1/16  whitespace-nowrap '
    },
    {
        value: 'companies_worked',
        label: 'Resolved',
        class: 'p-0 w-1/16  whitespace-nowrap',
    },
    {
        value: 'companies_to_be_worked',
        label: 'Unresolved',
        class: 'p-0 w-1/8  whitespace-nowrap'
    }
])
// const defaultOrdering = ref(['-date'])

const researchAssignments = ref(null)


const researchAssignmentsFilter = reactive({
    researchPage: {
        name: "research_page",
        label: "Research Page",
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"},
            {value: "vet_urls", label: "Vet URLs"},
            {value: "missing_url_or_zoom_info_companies", label: "Missing URL or ZoomInfo Companies"}
        ],
        widget: 'list-box',
        multiSelect: false,
        visible: true
    },
    user: {
        name: "user",
        label: "User",
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: setUserOptions.bind(null),
        awaitingOptions: false,
        visible: true
    }
})

const researchAssignmentsBulkOperations = reactive({
})

function setLoading(){
    isLoading.value = true
}

const menuOptions = reactive({
    selectAll: false,
    paginationArrows: true,
    totalResults: false,
    pageSize: true,
    refreshButton: true,
    filters: true,
    bulkOperations: false,
    addFormRows: false,
})

function setFilters(updatedFilters) {
    researchAssignmentsFilter.researchPage = updatedFilters.researchPage;
    researchAssignmentsFilter.user = updatedFilters.user;
}

async function loadResearchAssignments(fetchFilter='') {
    isLoading.value = true;
    const token = store.state.auth.token
    response.value = await getResearchAssignments(token, fetchFilter);
    isLoading.value = false;
}

async function setFilterOptions(filterName, queryParams='') {
    console.log('setFilterOptions', filterName)
    if(!researchAssignmentsFilter[filterName].awaitingOptions){
        if(researchAssignmentsFilter[filterName].setOptionsMethod){
            researchAssignmentsFilter[filterName].awaitingOptions = true
            researchAssignmentsFilter[filterName].setOptionsMethod(queryParams)
            setTimeout(() => {
                researchAssignmentsFilter[filterName].awaitingOptions = false;
            }, 30000)
        }
    }
}

function clearFilter(filterName) {
    if(Array.isArray(researchAssignmentsFilter[filterName].value)){
        researchAssignmentsFilter[filterName].value = []
    } else {
        researchAssignmentsFilter[filterName].value = null
    }
}



async function setUserOptions() {
    const payload = {
        endpoint: 'list_users',
        group: 'management_group&group=dev_group&group=account_manager_group&group=advanced_research_group',
        token: store.state.auth.token
    }
    const result = await getUsersByGroup(payload)
    researchAssignmentsFilter.user.options = [{value: "clear", label: "------------"}, ...result.users.map((user) => {
            return {value: user.id, label: `${user.first_name} ${user.last_name}`}
            }
        )]    
    userOptions.value = result.users.map((user) => {
            return {value: user.id, label: `${user.first_name} ${user.last_name}`}
            }
        )
}

setUserOptions()


</script>